import { render, staticRenderFns } from "./ShowcaseItem.vue?vue&type=template&id=ac2aa216&scoped=true&"
import script from "./ShowcaseItem.vue?vue&type=script&lang=ts&"
export * from "./ShowcaseItem.vue?vue&type=script&lang=ts&"
import style0 from "./ShowcaseItem.vue?vue&type=style&index=0&id=ac2aa216&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac2aa216",
  null
  
)

export default component.exports